import React, { Component } from 'react';

class generateEstimationLoader extends Component {
    constructor(props) {
        super(props);
    }

    render(){
        return (
            <div id="generate-estimation-loader" className={this.props.className}/>
        );
    }
}

export default generateEstimationLoader;
